import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import { ClassroomInviteCode } from "js/components/InviteCode/InviteCode";
import StandardModal from "js/components/shared/StandardModal";
import useStore from "stores/index";
import Radio from "js/components/Radio";
import { InfoBox } from "../shared/InfoBox";
import { PrimaryButton } from "../shared/button/PrimaryButton";
import Checkbox from "../shared/Checkbox";
import { default as IconPinClass } from "assets/IconPinClass.svg";

class ClassroomCreate extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			allowedClassrooms: useStore.getState().classroom.dataV2,
			classroomName: "",
			classroomNameUniqueError: "",
			classroomNameValid: false,
			loaded: false,
			code: undefined,
			codeExpiry: undefined,
			codeInviteEnabled: false,
			loadingCode: false,
			monitorModeChecked: false,
			pinned: false,
		};
		this.handleClose = this.handleClose.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.validateGroupName = this.validateGroupName.bind(this);
	}

	reset = () => {
		this.setState({
			classroomName: "",
			classroomNameUniqueError: "",
			classroomNameValid: false,
			codeInviteEnabled: false,
			code: undefined,
			codeExpiry: undefined,
			monitorModeChecked: false,
		});
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleSubmit = async (event) => {
		this.setState({ classroomNameValid: true, classroomNameUniqueError: "" });
		if (this.state.classroomNameValid || this.state.classroomNameValid === undefined) {
			var response = await this.props.onSubmit(
				this.state.classroomName.trim().toLowerCase(),
				this.state.code,
				this.state.codeExpiry - 0,
				this.state.monitorModeChecked,
				this.state.pinned
			);

			if (!response.error) {
				this.handleClose();
				this.reset();
			} else {
				this.setState({ classroomNameValid: false });
				this.setState({ classroomNameUniqueError: response.error });
			}
		}
		return false;
	};

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(newProps) {
		if (newProps["open"] !== this.props.open) {
			this.reset();
		}
	}

	validateGroupName = (groupName) => {
		const result = { valid: true, error: "" };
		for (let i = 0; i < this.state.allowedClassrooms.length; i++) {
			if (this.state.allowedClassrooms[i].name.toLowerCase() === groupName.toLowerCase()) {
				result["valid"] = false;
				result["error"] = "This classroom name is already used. Please choose a different one.";
			}
		}
		return result;
	};

	handleClassroomNameChange = (event) => {
		const checkName = this.validateGroupName(event.target.value.trim());
		this.setState({ classroomNameValid: checkName["valid"] });
		this.setState({ classroomNameUniqueError: checkName["error"] });
		this.setState({ classroomName: event.target.value });
	};

	handleClassroomNameChangeNoValidate = (event) => {
		this.setState({ classroomName: event.target.value });
		this.setState({ classroomNameValid: true });
	};

	actions = () => {
		return (
			<div>
				<PrimaryButton className="mui-flat-button" label="Save" onClick={this.handleSubmit} />
			</div>
		);
	};

	handleModeChange = (value) => {
		// Ensure we clear the code if monitor mode is selected in the "mode" radio button.
		this.setState({
			monitorModeChecked: value === "monitor",
			codeInviteEnabled: false,
			code: value === "monitor" ? "" : this.state.code,
		});
	};

	render() {
		return (
			<StandardModal
				size="medium"
				title={this.props.heading}
				actions={this.actions()}
				open={this.props.open}
				close={this.handleClose}
				bodyClass={this.props.bodyClass}
			>
				<div style={{ display: "flex", flexDirection: "row" }}>
					<div className="ClassroomCreate_infoContent">
						<div>Class name</div>
						<TextField
							id="classroomName"
							className="ClassroomCreate_muiInput"
							data-cy="class_room-input"
							label="Enter a class name"
							value={this.state.classroomName}
							onChange={this.handleClassroomNameChangeNoValidate}
							error={this.state.classroomName.length > 0 && !this.state.classroomNameValid}
							helperText={this.state.classroomNameUniqueError}
							autoFocus
						/>
					</div>
					<ClassroomInviteCode
						codeInviteEnabled={this.state.codeInviteEnabled}
						codeInviteAllowed={!this.state.monitorModeChecked}
						code={this.state.code}
						codeExpiry={this.state.codeExpiry}
						codeCallback={(enabled, code, expiry) => {
							this.setState({
								codeInviteEnabled: enabled && !this.state.monitorModeChecked,
								codeInviteAllowed: !this.state.monitorModeChecked,
								code: code,
								codeExpiry: expiry,
							});
						}}
					/>
				</div>
				<br />
				{this.props.isMonitoringAuthorised ? (
					<div>
						<div
							style={{
								display: "flex",
								flexDirection: "row",
							}}
						>
							<Radio
								name="mode"
								value="teaching"
								label="Teaching Mode"
								className="ClassroomCreate_monitorRadio"
								onChange={this.handleModeChange}
								checked={!this.state.monitorModeChecked}
							/>

							<Radio
								name="mode"
								value="monitor"
								label="Monitor Mode"
								className="ClassroomCreate_monitorRadio"
								onChange={this.handleModeChange}
								checked={this.state.monitorModeChecked}
							/>
						</div>
						<InfoBox>
							{this.state.monitorModeChecked
								? "Use Monitor Mode when you need to observe students without interacting with them."
								: "Use Teaching Mode when you need to create rules and interact with your students."}
						</InfoBox>
					</div>
				) : null}
				{
					<>
						<br />
						<div style={{ display: "flex", flexDirection: "row", alignItems: "start" }}>
							<Checkbox checked={this.state.pinned} onChecked={(isChecked) => this.setState({ pinned: isChecked })} label="" />
							<div>
								<div className="ClassroomCreate_Pin_Container">
									<div className="ClassroomCreate_Pin">
										<IconPinClass />
									</div>
									<div>Pin this class</div>
								</div>
								<div className="ClassroomCreate_Pin_Container_Text_Secondary">
									This will pin a class to the top of your workspace for quick and easy access
								</div>
							</div>
						</div>
					</>
				}
			</StandardModal>
		);
	}
}

ClassroomCreate.propTypes = {
	isMonitoringAuthorised: PropTypes.bool,
	open: PropTypes.bool,
	heading: PropTypes.string,
	onSubmit: PropTypes.func,
	onClose: PropTypes.func,
	bodyClass: PropTypes.string,
};

export default ClassroomCreate;
